/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightPlusKreis: {
    name: 'big-light-plus-kreis';
    data: string;
} = {
    name: 'big-light-plus-kreis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M96 61.5H66.5V32a2.5 2.5 0 0 0-5 0v29.5H32a2.5 2.5 0 0 0 0 5h29.5V96a2.5 2.5 0 0 0 5 0V66.5H96a2.5 2.5 0 0 0 0-5"/><path d="M64 5.5A58.5 58.5 0 1 0 122.5 64 58.56 58.56 0 0 0 64 5.5m0 112A53.5 53.5 0 1 1 117.5 64 53.56 53.56 0 0 1 64 117.5"/></svg>`,
};
